import { Link, useLocation } from 'react-router-dom';
import { Home, Map, Plus, FileText, User } from 'lucide-react';
import { useTranslation } from '@/lib/i18n';
import { useTheme } from '@/lib/ThemeContext';

export default function FooterNav() {
    const { t } = useTranslation();
    const location = useLocation();
    const { themeMode } = useTheme();

    const isActive = (path: string) => location.pathname === path;

    // Hide footer on admin pages
    if (location.pathname.startsWith('/admin')) {
        return null;
    }

    return (
        <div className={`fixed bottom-0 left-0 right-0 border-t z-50 safe-area-bottom transition-all duration-300 ${themeMode === 'v2'
            ? 'bg-[#111827] border-slate-800 shadow-[0_-10px_20px_rgba(0,0,0,0.3)]'
            : 'bg-white/80 backdrop-blur-md border-slate-200/60'
            }`}>
            <div className="grid grid-cols-5 gap-0 px-2 py-2">
                {/* Home */}
                <Link
                    to="/"
                    className={`flex flex-col items-center gap-1 py-2 rounded-lg transition-colors ${isActive('/')
                        ? 'text-blue-500'
                        : themeMode === 'v2' ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-700'
                        }`}
                >
                    <Home className="w-6 h-6" />
                    <span className="text-[10px] font-medium">{t('nav.home')}</span>
                </Link>

                {/* Map */}
                <Link
                    to="/map"
                    className={`flex flex-col items-center gap-1 py-2 rounded-lg transition-colors ${isActive('/map')
                        ? 'text-blue-500'
                        : themeMode === 'v2' ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-700'
                        }`}
                >
                    <Map className="w-6 h-6" />
                    <span className="text-[10px] font-medium">{t('nav.map')}</span>
                </Link>

                {/* New Report - Prominent Center Button */}
                <Link
                    to="/report"
                    className="flex flex-col items-center justify-center -mt-4"
                >
                    <div className={`w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center shadow-lg active:scale-95 transition-all ${themeMode === 'v2' ? 'shadow-blue-600/40' : 'shadow-blue-600/30'}`}>
                        <Plus className="w-7 h-7 text-white" />
                    </div>
                    <span className={`text-[10px] font-medium mt-1 ${themeMode === 'v2' ? 'text-slate-400' : 'text-slate-600'}`}>{t('nav.report')}</span>
                </Link>

                {/* My Reports */}
                <Link
                    to="/track"
                    className={`flex flex-col items-center gap-1 py-2 rounded-lg transition-colors ${isActive('/track')
                        ? 'text-blue-500'
                        : themeMode === 'v2' ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-700'
                        }`}
                >
                    <FileText className="w-6 h-6" />
                    <span className="text-[10px] font-medium">{t('nav.my_reports')}</span>
                </Link>

                {/* Profile */}
                <Link
                    to="/profile"
                    className={`flex flex-col items-center gap-1 py-2 rounded-lg transition-colors ${isActive('/profile')
                        ? 'text-blue-500'
                        : themeMode === 'v2' ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-700'
                        }`}
                >
                    <User className="w-6 h-6" />
                    <span className="text-[10px] font-medium">{t('nav.profile')}</span>
                </Link>
            </div>
        </div>
    );
}
